import { render } from "./Scoring.vue?vue&type=template&id=71271dea&scoped=true"
import script from "./Scoring.vue?vue&type=script&lang=js"
export * from "./Scoring.vue?vue&type=script&lang=js"

import "./Scoring.vue?vue&type=style&index=0&id=71271dea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-71271dea"

export default script